import type { ComponentType } from 'react'
import { type DropzoneOptions, useDropzone } from 'react-dropzone'

type WithDroppableOptions = {
  onDrop?: (acceptedFiles: File[]) => void
  dropzoneOptions?: Omit<DropzoneOptions, 'onDrop'>
}

type WithDroppableProps = {
  isDropDisabled?: boolean
}

export const withDroppable = <T extends object>(WrappedComponent: ComponentType<T>, options?: WithDroppableOptions) => {
  return (props: T & WithDroppableProps) => {
    const { isDropDisabled, ...restProps } = props

    const { getRootProps, isDragActive } = useDropzone({
      ...options?.dropzoneOptions,
      disabled: isDropDisabled,
      onDrop: (acceptedFiles) => {
        options?.onDrop?.(acceptedFiles)
      },
    })

    return (
      <div {...getRootProps()} className="relative">
        <WrappedComponent {...(restProps as T)} />
        {isDragActive && (
          <div className="absolute inset-0 bg-blue-500/10 flex items-center justify-center">
            <span className="text-blue-700 font-medium">Drop files here</span>
          </div>
        )}
      </div>
    )
  }
}
